<template>
  <div class="information">
    <div class="information-c">
      <!-- 手机号码 -->
      <div style="font-family: MicrosoftYaHei; margin-bottom: 20px">
        <span class="asdasd">手机号码</span>
        <p class="asdasd" v-if="isEdit">{{ phoneNumber }}</p>
        <input
          class="asdasd"
          v-if="!isEdit"
          type="text"
          v-model="phoneNumber"
          ref="phoneNumber"
          @blur="phoneNumberBlur"
        />
      </div>
      <!-- 修改密码 -->
      <div style="font-family: MicrosoftYaHei; margin-bottom: 20px">
        <span class="asdasd">修改密码</span>
        <p class="asdasd" v-if="isEdit">{{ pwd }}</p>
        <input
          class="asdasd"
          v-if="!isEdit"
          type="password"
          v-model="pwd"
          @blur="phoneNumberBlur"
        />
      </div>
      <!-- 身份证号 -->
      <div style="font-family: MicrosoftYaHei; margin-bottom: 20px">
        <span class="asdasd">身份证号</span>
        <p class="asdasd" v-if="isEdit">{{ cardNumber }}</p>
        <input
          class="asdasd"
          v-if="!isEdit"
          type="text"
          v-model="cardNumber"
          @blur="phoneNumberBlur"
        />
      </div>
      <!-- 邮箱账号 -->
      <div style="font-family: MicrosoftYaHei; margin-bottom: 20px">
        <span class="asdasd">邮箱账号</span>
        <p class="asdasd" v-if="isEdit">{{ phoneNumber }}</p>
        <input
          class="asdasd"
          v-if="!isEdit"
          type="text"
          v-model="email"
          ref="email"
          @blur="emailBlur"
        />
      </div>
      <!-- 所在地区 -->
      <div style="font-family: MicrosoftYaHei; margin-bottom: 20px">
        <span class="asdasd">所在地区</span
        ><Select
          v-model="formValidate.province"
          style="width: 110px; margin-right: 8px; height: 40px"
          @on-change="changeProvince"
          :placeholder="defaultAddress.province"
        >
          <Option
            v-for="item in provinceArr"
            :value="item.encoded"
            :key="item.encoded"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-model="formValidate.city"
          style="width: 110px; margin-right: 8px; height: 40px"
          @on-change="changeCity"
          :placeholder="defaultAddress.city"
        >
          <Option
            v-for="item in cityArr"
            :value="item.encoded"
            :key="item.encoded"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-model="formValidate.county"
          style="width: 110px; margin-right: 0px; height: 40px"
          @on-change="changeCounty"
          :placeholder="defaultAddress.county"
        >
          <Option
            v-for="item in countyArr"
            :value="item.encoded"
            :key="item.encoded"
            >{{ item.name }}</Option
          >
        </Select>
      </div>

      <!-- 状态 -->
      <div
        style="
          font-family: MicrosoftYaHei;
          margin-bottom: 20px;
          display: inline-block;
        "
      >
        <span class="asdasd">状态</span>
        <div style="display: inline-block; height: 40px; line-height: 40px">
          <img
            :src="statusFlag == 0 ? img2 : img1"
            alt=""
            style="
              vertical-align: middle;
              display: inline-block;
              width: 15px;
              height: 15px;
              margin-right: 10px;
              cursor: pointer;
            "
            @click="radioFn('status', 0)"
          />
          <div
            style="
              display: inline-block;
              margin-right: 40px;
              color: #333333;
              font-size: 14px;
            "
          >
            待业
          </div>
          <img
            :src="statusFlag == 1 ? img2 : img1"
            alt=""
            style="
              vertical-align: middle;
              display: inline-block;
              width: 15px;
              height: 15px;
              margin-right: 10px;
              cursor: pointer;
            "
            @click="radioFn('status', 1)"
          />
          <div style="display: inline-block; color: #333333; font-size: 14px">
            在职
          </div>
        </div>
      </div>

      <!-- 修改信息按钮 -->
      <div v-if="isEdit" class="infor-reset-btn" @click="editinfo">编辑</div>
      <div style="text-align: center;" v-else>
        <p
         @click="isEdit=!isEdit"
          style="
            display: inline-block;
            width: 100px;
            height: 40px;
            background: #e5e5e5;
            border-radius: 3px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            line-height: 40px;
            cursor: pointer;
            margin-right:60px;
          "
        >
          取消
        </p>
        <p
          style="
            display: inline-block;
            width: 100px;
            height: 40px;
            background: #3476C1;
            border-radius: 3px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
          "
          @click="resetBtnFn()"
        >
          确定
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import areasData from "@/assets/areas.json";

export default {
  name: "information",
  data() {
    return {
      isEdit: true,
      provinceArr: areasData.data,
      cityArr: [],
      countyArr: [],
      formValidate: {
        province: "",
        city: "",
        county: "",
      },
      defaultAddress: {
        province: "请选择",
        city: "请选择",
        county: "请选择",
      },
      cprovinceCode: 0, //省编码
      cityCode: 0, //市编码
      countyCode: 0, //区编码
      tabIndex: 1,
      statusFlag: 0, //状态单选框
      img1: require("../../static/login/i6.png"), //单选图标
      img2: require("../../static/login/i7.png"),

      pwd: "",
      cardNumber: "",
      email: "",
      emailCheck: true,
      phoneNumber: "",
      phoneNumberCheck: true,
      errortext: "",
    };
  },
  methods: {
    editinfo() {
      this.isEdit = false;
    },
    radioFn(type, val) {
      if (type == "status") {
        this.statusFlag = val;
      } else {
      }
    },
    phoneNumberBlur() {
      //判断手机号是否存在
      let phoneNumber = this.$refs.phoneNumber.value;
      if (!/^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(this.$refs.phoneNumber.value)) {
        this.phoneNumberCheck = false;
        this.errortext = "请输入正确手机号";
      } else {
        this.phoneNumberCheck = true;
        this.errortext = "";
      }
    },
    emailBlur() {
      //判断邮箱是否存在
      let email = this.$refs.email.value;
      if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(this.$refs.email.value)) {
        this.emailCheck = false;
        this.errortext = "邮箱格式错误";
      } else {
        this.emailCheck = true;
        this.errortext = "";
      }
    },
    resetBtnFn() {
      // user/me-msg/update

      // pwd;
      // phoneNum;
      // email;
      // onJob; // 0待业
      // provinceCode;
      // cityCode;
      // areaCode;

      let param = {
        pwd: this.pwd,
        phoneNum: this.phoneNumber,
        email: this.email,
        onJob: this.statusFlag,
        provinceCode: this.provinceCode,
        cityCode: this.cityCode,
        areaCode: this.areaCode,
      };
      this.$axios
        .post("/v1/cloud/user/me-msg/update", param, {})
        .then(({ data }) => {
          console.log(data);
          if (data === true) {
            this.$Message.success("修改成功！");
            // inforStatus
            // localStorage.setItem('completeStatus','1');  //是否完善信息
            // this.$router.push({name:'home'})
          }
        })
        .catch((error) => {
          var err = error.response;
          if (err.status == 400) {
            this.$Message.error(err.data.message);
          }
          if (err.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    },
    changeProvince(val) {
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (this.formValidate.province == this.provinceArr[i].encoded) {
          this.cityArr = this.provinceArr[i].cityRespList;
          this.formValidate.county = "";
          this.countyArr = [];
        }
      }
      this.rovinceCode = val;
    },
    changeCity(val) {
      for (var i = 0; i < this.cityArr.length; i++) {
        if (this.formValidate.city == this.cityArr[i].encoded) {
          this.countyArr = this.cityArr[i].countyRespList;
        }
      }
      this.cityCode = val;
    },
    changeCounty(s) {
      console.log("区", s, this.formValidate.county);
      this.countyCode = s;
    },
  },
  created() {
    this.$axios
      .get("/v1/cloud/user/me-msg", {})
      .then(({ data }) => {
        if (data) {
          this.statusFlag = data.onJob;
          this.email = data.email;
          this.pwd = data.pwd;
          this.phoneNumber = data.phoneNum;
          this.cardNumber = data.cardNum;
        }
        console.log(data, 8888);
      })
      .catch((error) => {
        // var err = error.response
        // if(err.status == 400){
        //     this.$Message.error(err.data.message);
        // }
        // if(err.status == 401){
        //     this.$router.push({name:'login'})
        // }
      });
  },
  mounted() {},
};
</script>

<style lang="less">
input.asdasd {
  width: 350px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 3px;
  box-sizing: border-box;
  text-indent: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
span.asdasd {
  display: inline-block;
  width: 60px;
  text-align: right;
  margin-right: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 40px;
}
p.asdasd {
  display: inline-block;
  width: 350px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
}
a {
  text-decoration: none;
}
li {
  list-style: none;
}
input {
  outline: none;
  border: none;
  background: rgba(0, 0, 0, 0);
}
.information {
  width: 950px;
  height: 674px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  .information-c {
    width: 430px;
    height: auto;
    margin: 0 auto;
    padding-top: 50px;
    // background:rgba(255,255,255,1);
    // border:1px solid rgba(238,238,238,1);border-radius:4px;
    .information-input {
      width: 350px;
      height: 40px;
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      padding-left: 10px;
      img {
        display: block;
        float: left;
        width: 18px;
        height: 18px;
        margin-left: 16px;
        margin-top: 8px;
        margin-right: 12px;
      }
      input {
        float: left;
        width: 300px;
        height: 100%;
        font-size: 15px;
        // color:#bfbfbf;
      }
      span {
        display: block;
        float: right;
        height: 36px;
        line-height: 36px;
        padding-right: 8px;
        color: #bfbfbf;
      }
    }
    .infor-reset-btn {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #3476c1;
      border-radius: 3px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin: 30px auto 0;
      cursor: pointer;
    }
    //省市区三级联动
    .infor-area {
      .ivu-select-single .ivu-select-selection {
        height: 50px;
        line-height: 50px;
        background: rgba(250, 250, 250, 1);
        border: 1px solid rgba(238, 238, 238, 1);
      }
      .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
      .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 50px;
        line-height: 50px;
        color: #333333;
      }
    }
  }
}
</style>